export default "__VITE_ASSET__b18c786c__"